export default {"src":"/uk/_next/static/media/noNetworkConnection.a468a3bb.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};